<template>
	<div>
		<action-sidebar
			:title="title"
			:value="true"
			:width="450"
			@close-modal="closeModal"
		>
			<cost-center-form
				:id="id"
				:father-id="fatherId"
				:code="code"
				:level="level"
				:is-edit="isEdit"
				@on-close="closeModal"
			/>
		</action-sidebar>
	</div>
</template>

<script>
	import actionSidebar from '@/components/shared/action-sidebar';
	import costCenterForm from '@/components/cost-centers/cost-center-form';
	import { COSTS_CENTERS } from '@/shared/action-codes';

	// Recurso ACL del módulo de centros de costo (clave en el mapa de permisos).
	// La ruta de este modal se llama 'page-cost-center-new', que NO está en el
	// mapa, por eso usamos fijo el recurso padre.
	const PERMS_RESOURCE = 'center-of-cost';

	// Valida el permiso correspondiente a la acción antes de mostrar el modal.
	// - Editar            -> 'update'
	// - Agregar hijo       -> 'create'      (tiene fatherId)
	// - Crear centro raíz  -> 'cost-center-new'
	function created() {
		let action;
		if (this.isEdit) {
			action = 'update';
		} else if (this.fatherId) {
			action = 'create';
		} else {
			action = 'cost-center-new';
		}
		if (!this.$can(PERMS_RESOURCE, action)) {
			if (typeof this.showNotification === 'function') {
				this.showNotification('No tienes permiso para esta acción.', 'warning');
			}
			this.goTo(COSTS_CENTERS, { query: this.$route.query });
		}
	}

	function closeModal() {
		this.goTo(COSTS_CENTERS, { query: this.$route.query });
	}

	function title() {
		const module = 'Centro de Costos';
		return this.id ? `Editar ${module}` : `Crear ${module}`;
	}

	export default {
		name: 'page-cost-center-new',
		components: {
			actionSidebar,
			costCenterForm,
		},
		created,
		computed: {
			title,
		},
		methods: {
			closeModal,
		},
		props: {
			id: [Number, String],
			fatherId: {
				type: Number,
				default: () => null,
			},
			code: {
				type: String,
				default: '',
			},
			level: {
				type: Number,
				default: 1,
			},
			isEdit: {
				type: Boolean,
				default: false,
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/pages/cost-centers/page-cost-center-new.vue